import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Hint } from 'ui';

export default function Question(props) {
  const {
    node,
    whenAnswered,
    value,
    children,
    options = { hideTitle: false },
  } = props;
  const [answer, setAnswer] = useState(value);
  const { hint, items, greeting: title } = node;

  return (
    <div className="flex flex-col space-y-6">
      {!options.hideTitle && (
        <div className="flex flex-col space-y-1">
          <h3 className="text-base md:text-2xl text-bleu-hellio-500 text-center">
            {title}
          </h3>
          {node.subtitle && (
            <p className="text-center text-xs text-bleu-hellio-500">
              {node.subtitle}
            </p>
          )}
        </div>
      )}

      <div className="w-full flex flex-row items-center justify-center gap-4">
        {items &&
          items.map((item) => {
            return (
              <label
                key={item.short}
                className={`flex items-center justify-center bg-white border-[2px] border-solid rounded-md cursor-pointer min-w-40 ${answer === item.short ? 'border-grand-public-500' : 'border-transparent'}`}
              >
                <div
                  className={`flex flex-col items-center p-6 ${item.icon ? 'py-6' : 'py-4'}`}
                >
                  {item.icon && (
                    <span className="flex h-14 w-14">
                      <img
                        src={item.icon}
                        alt={item.short}
                        className="w-full h-full"
                      />
                    </span>
                  )}

                  <div className="flex">
                    <h5
                      className={`font-normal ${
                        answer === item.short ? 'text-grand-public-500' : ''
                      }`}
                    >
                      {item.long}
                    </h5>
                  </div>
                </div>

                <input
                  type={item.type}
                  name={item.name}
                  value={item.short}
                  onChange={(e) => {
                    setAnswer(item.short);
                    whenAnswered(e);
                  }}
                  className="hidden"
                />
              </label>
            );
          })}
      </div>

      {/* Message d'information */}
      {hint && (
        <div className="w-full max-w-xl mx-auto">
          <Hint
            title={hint.title}
            content={
              <div
                className="flex text-xs"
                dangerouslySetInnerHTML={{
                  __html: hint.description,
                }}
              />
            }
          />
        </div>
      )}

      {children && children}
    </div>
  );
}

Question.propTypes = {
  node: PropTypes.object,
  children: PropTypes.element,
  whenAnswered: PropTypes.func,
  value: PropTypes.string,
  options: PropTypes.objectOf({
    hideTitle: PropTypes.bool,
  }),
};
